module.exports = __webpack_public_path__ + "static/The_Europeans-55a994374ef8eccbd6867dfc5fac0abb.jpeg";